import {ActorSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/Actor';
import {CameraControlsSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/CameraControls';
import {MaterialsNetworkSopNode} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/MaterialsNetwork';
import {GeoObjNode} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/Geo';
import {RootManagerNode} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/manager/Root';
import {ExampleData, DataCallbackOptions} from '../../Common';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	function create_lights(parentNode: RootManagerNode) {
		var lights = parentNode.createNode('geo');
		lights.setName('lights');
		function create_hemisphereLight1(lights: GeoObjNode) {
			var hemisphereLight1 = lights.createNode('hemisphereLight');
			hemisphereLight1.setName('hemisphereLight1');
			hemisphereLight1.uiData.setPosition(-350, -50);
			hemisphereLight1.p.intensity.set(0.64);
			hemisphereLight1.params.postCreateSpareParams();
			hemisphereLight1.params.runOnSceneLoadHooks();
			return hemisphereLight1;
		}
		function create_merge1(lights: GeoObjNode) {
			var merge1 = lights.createNode('merge');
			merge1.setName('merge1');
			merge1.uiData.setPosition(-200, 300);
			merge1.io.inputs.overrideClonedState(true);
			merge1.flags.display.set(true);
			merge1.params.postCreateSpareParams();
			merge1.params.runOnSceneLoadHooks();
			return merge1;
		}
		function create_polarTransform1(lights: GeoObjNode) {
			var polarTransform1 = lights.createNode('polarTransform');
			polarTransform1.setName('polarTransform1');
			polarTransform1.uiData.setPosition(50, 50);
			polarTransform1.io.inputs.overrideClonedState(true);
			polarTransform1.p.longitude.set('$T*2-50');
			polarTransform1.p.latitude.set(43.2);
			polarTransform1.p.depth.set(10);
			polarTransform1.params.postCreateSpareParams();
			polarTransform1.params.runOnSceneLoadHooks();
			return polarTransform1;
		}
		function create_spotLight1(lights: GeoObjNode) {
			var spotLight1 = lights.createNode('spotLight');
			spotLight1.setName('spotLight1');
			spotLight1.uiData.setPosition(50, -100);
			spotLight1.p.showHelper.set(true);
			spotLight1.p.castShadow.set(true);
			spotLight1.params.postCreateSpareParams();
			spotLight1.params.runOnSceneLoadHooks();
			return spotLight1;
		}
		var hemisphereLight1 = create_hemisphereLight1(lights);
		var merge1 = create_merge1(lights);
		var polarTransform1 = create_polarTransform1(lights);
		var spotLight1 = create_spotLight1(lights);
		merge1.setInput(0, hemisphereLight1);
		merge1.setInput(1, polarTransform1);
		polarTransform1.setInput(0, spotLight1);
		lights.uiData.setPosition(-50, -50);
		lights.flags.display.set(true);
		lights.params.postCreateSpareParams();
		lights.params.runOnSceneLoadHooks();
		return lights;
	}
	function create_cameras(parentNode: RootManagerNode) {
		var cameras = parentNode.createNode('geo');
		cameras.setName('cameras');
		function create_cameraControls1(cameras: GeoObjNode) {
			var cameraControls1 = cameras.createNode('cameraControls');
			cameraControls1.setName('cameraControls1');
			function create_cameraOrbitControls1(cameraControls1: CameraControlsSopNode) {
				var cameraOrbitControls1 = cameraControls1.createNode('cameraOrbitControls');
				cameraOrbitControls1.setName('cameraOrbitControls1');
				cameraOrbitControls1.uiData.setPosition(0, 0);
				cameraOrbitControls1.p.target.set([0.10945962587829487, 2.285542484621549, -0.022589641314228144]);
				cameraOrbitControls1.params.postCreateSpareParams();
				cameraOrbitControls1.params.runOnSceneLoadHooks();
				return cameraOrbitControls1;
			}
			create_cameraOrbitControls1(cameraControls1);
			cameraControls1.uiData.setPosition(-200, 50);
			cameraControls1.flags.display.set(true);
			cameraControls1.p.node.set('cameraOrbitControls1');
			cameraControls1.params.postCreateSpareParams();
			cameraControls1.params.runOnSceneLoadHooks();
			return cameraControls1;
		}
		function create_perspectiveCamera_MAIN(cameras: GeoObjNode) {
			var perspectiveCamera_MAIN = cameras.createNode('perspectiveCamera');
			perspectiveCamera_MAIN.setName('perspectiveCamera_MAIN');
			perspectiveCamera_MAIN.uiData.setPosition(-200, -50);
			perspectiveCamera_MAIN.p.position.set([6.5, 2.9999999999999996, 6.3]);
			perspectiveCamera_MAIN.params.postCreateSpareParams();
			perspectiveCamera_MAIN.params.runOnSceneLoadHooks();
			return perspectiveCamera_MAIN;
		}
		var cameraControls1 = create_cameraControls1(cameras);
		var perspectiveCamera_MAIN = create_perspectiveCamera_MAIN(cameras);
		cameraControls1.setInput(0, perspectiveCamera_MAIN);
		cameras.uiData.setPosition(-50, 50);
		cameras.flags.display.set(true);
		cameras.params.postCreateSpareParams();
		cameras.params.runOnSceneLoadHooks();
		return cameras;
	}
	function create_character(parentNode: RootManagerNode) {
		var character = parentNode.createNode('geo');
		character.setName('character');
		function create_actor1(character: GeoObjNode) {
			var actor1 = character.createNode('actor');
			actor1.setName('actor1');
			function create_animationActionFadeIn1(actor1: ActorSopNode) {
				var animationActionFadeIn1 = actor1.createNode('animationActionFadeIn');
				animationActionFadeIn1.setName('animationActionFadeIn1');
				animationActionFadeIn1.uiData.setPosition(650, -100);
				animationActionFadeIn1.params.postCreateSpareParams();
				animationActionFadeIn1.params.runOnSceneLoadHooks();
				return animationActionFadeIn1;
			}
			function create_animationAction_Walk(actor1: ActorSopNode) {
				var animationAction_Walk = actor1.createNode('animationAction');
				animationAction_Walk.setName('animationAction_Walk');
				animationAction_Walk.uiData.setPosition(400, 0);
				animationAction_Walk.p.clipName.set('Walk');
				animationAction_Walk.params.postCreateSpareParams();
				animationAction_Walk.params.runOnSceneLoadHooks();
				return animationAction_Walk;
			}
			function create_animationMixer1(actor1: ActorSopNode) {
				var animationMixer1 = actor1.createNode('animationMixer');
				animationMixer1.setName('animationMixer1');
				animationMixer1.uiData.setPosition(50, -100);
				animationMixer1.params.postCreateSpareParams();
				animationMixer1.params.runOnSceneLoadHooks();
				return animationMixer1;
			}
			function create_animationMixerUpdate1(actor1: ActorSopNode) {
				var animationMixerUpdate1 = actor1.createNode('animationMixerUpdate');
				animationMixerUpdate1.setName('animationMixerUpdate1');
				animationMixerUpdate1.uiData.setPosition(400, -350);
				animationMixerUpdate1.params.postCreateSpareParams();
				animationMixerUpdate1.params.runOnSceneLoadHooks();
				return animationMixerUpdate1;
			}
			function create_onScenePlayState1(actor1: ActorSopNode) {
				var onScenePlayState1 = actor1.createNode('onScenePlay');
				onScenePlayState1.setName('onScenePlayState1');
				onScenePlayState1.uiData.setPosition(400, -200);
				onScenePlayState1.params.postCreateSpareParams();
				onScenePlayState1.params.runOnSceneLoadHooks();
				return onScenePlayState1;
			}
			function create_onTick1(actor1: ActorSopNode) {
				var onTick1 = actor1.createNode('onTick');
				onTick1.setName('onTick1');
				onTick1.uiData.setPosition(250, -450);
				onTick1.params.postCreateSpareParams();
				onTick1.params.runOnSceneLoadHooks();
				return onTick1;
			}
			var animationActionFadeIn1 = create_animationActionFadeIn1(actor1);
			var animationAction_Walk = create_animationAction_Walk(actor1);
			var animationMixer1 = create_animationMixer1(actor1);
			var animationMixerUpdate1 = create_animationMixerUpdate1(actor1);
			var onScenePlayState1 = create_onScenePlayState1(actor1);
			var onTick1 = create_onTick1(actor1);
			animationActionFadeIn1.setInput('trigger', onScenePlayState1);
			animationActionFadeIn1.setInput('AnimationAction', animationAction_Walk, 'animationAction');
			animationAction_Walk.setInput('AnimationMixer', animationMixer1, 'AnimationMixer');
			animationMixerUpdate1.setInput('trigger', onTick1, 'trigger');
			animationMixerUpdate1.setInput('AnimationMixer', animationMixer1, 'AnimationMixer');
			actor1.uiData.setPosition(-100, 300);
			actor1.flags.display.set(true);
			actor1.params.postCreateSpareParams();
			actor1.params.runOnSceneLoadHooks();
			return actor1;
		}
		function create_fileGLTF1(character: GeoObjNode) {
			var fileGLTF1 = character.createNode('fileGLTF');
			fileGLTF1.setName('fileGLTF1');
			fileGLTF1.uiData.setPosition(-100, -50);
			fileGLTF1.p.url.set(
				'https://raw.githubusercontent.com/polygonjs/polygonjs-assets/master/models/resources/quaternius/animals/Alpaca.gltf'
			);
			fileGLTF1.params.postCreateSpareParams();
			fileGLTF1.params.runOnSceneLoadHooks();
			return fileGLTF1;
		}
		function create_objectProperties1(character: GeoObjNode) {
			var objectProperties1 = character.createNode('objectProperties');
			objectProperties1.setName('objectProperties1');
			objectProperties1.uiData.setPosition(-100, 100);
			objectProperties1.p.group.set('*');
			objectProperties1.p.tcastShadow.set(true);
			objectProperties1.params.postCreateSpareParams();
			objectProperties1.params.runOnSceneLoadHooks();
			return objectProperties1;
		}
		var actor1 = create_actor1(character);
		var fileGLTF1 = create_fileGLTF1(character);
		var objectProperties1 = create_objectProperties1(character);
		actor1.setInput(0, objectProperties1);
		objectProperties1.setInput(0, fileGLTF1);
		character.uiData.setPosition(-50, -150);
		character.flags.display.set(true);
		character.params.postCreateSpareParams();
		character.params.runOnSceneLoadHooks();
		return character;
	}
	function create_ground(parentNode: RootManagerNode) {
		var ground = parentNode.createNode('geo');
		ground.setName('ground');
		function create_MAT(ground: GeoObjNode) {
			var MAT = ground.createNode('materialsNetwork');
			MAT.setName('MAT');
			function create_shadow1(MAT: MaterialsNetworkSopNode) {
				var shadow1 = MAT.createNode('shadow');
				shadow1.setName('shadow1');
				shadow1.uiData.setPosition(-150, 100);
				shadow1.p.color.set([0.1803921568627451, 0.09803921568627451, 0.13725490196078433]);
				shadow1.p.transparent.set(true);
				shadow1.params.postCreateSpareParams();
				shadow1.params.runOnSceneLoadHooks();
				return shadow1;
			}
			create_shadow1(MAT);
			MAT.uiData.setPosition(-300, 300);
			MAT.params.postCreateSpareParams();
			MAT.params.runOnSceneLoadHooks();
			return MAT;
		}
		function create_material1(ground: GeoObjNode) {
			var material1 = ground.createNode('material');
			material1.setName('material1');
			material1.uiData.setPosition(-100, 300);
			material1.flags.display.set(true);
			material1.p.material.set('../MAT/shadow1');
			material1.params.postCreateSpareParams();
			material1.params.runOnSceneLoadHooks();
			return material1;
		}
		function create_plane1(ground: GeoObjNode) {
			var plane1 = ground.createNode('plane');
			plane1.setName('plane1');
			plane1.uiData.setPosition(-100, 150);
			plane1.p.size.set([88, 88]);
			plane1.p.useSegmentsCount.set(true);
			plane1.params.postCreateSpareParams();
			plane1.params.runOnSceneLoadHooks();
			return plane1;
		}
		create_MAT(ground);
		var material1 = create_material1(ground);
		var plane1 = create_plane1(ground);
		material1.setInput(0, plane1);
		ground.uiData.setPosition(-50, -250);
		ground.flags.display.set(true);
		ground.params.postCreateSpareParams();
		ground.params.runOnSceneLoadHooks();
		return ground;
	}
	create_lights(root);
	create_cameras(root);
	create_character(root);
	create_ground(root);
	scene.setFrame(0);
	return {
		scene,
		cameraPath: '/cameras/cameras:sopGroup/perspectiveCamera_MAIN',
		focusedNodes: [],
		autoLayout: false,
		playWhenLoaded: true,
	};
}
// export const matShadow = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/mat/shadow`,
// 		createData,
// 		relatedNodes: [ShadowMatNode],
// 	}),
// ];
